/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  CodeRuntime,
  CodeRuntime$inboundSchema,
  CodeRuntime$outboundSchema,
} from "./coderuntime.js";
import {
  RuntimeResourceUsage,
  RuntimeResourceUsage$inboundSchema,
  RuntimeResourceUsage$Outbound,
  RuntimeResourceUsage$outboundSchema,
} from "./runtimeresourceusage.js";

export type CodeResult = {
  sessionId: string;
  runtime: CodeRuntime;
  cwd: string;
  stdout?: string | undefined;
  stderr?: string | undefined;
  exitCode: number;
  filesChanged?: Array<string> | undefined;
  resourceUsage?: RuntimeResourceUsage | null | undefined;
};

/** @internal */
export const CodeResult$inboundSchema: z.ZodType<
  CodeResult,
  z.ZodTypeDef,
  unknown
> = z.object({
  session_id: z.string(),
  runtime: CodeRuntime$inboundSchema,
  cwd: z.string(),
  stdout: z.string().default(""),
  stderr: z.string().default(""),
  exit_code: z.number().int(),
  files_changed: z.array(z.string()).optional(),
  resource_usage: z.nullable(RuntimeResourceUsage$inboundSchema).optional(),
}).transform((v) => {
  return remap$(v, {
    "session_id": "sessionId",
    "exit_code": "exitCode",
    "files_changed": "filesChanged",
    "resource_usage": "resourceUsage",
  });
});
/** @internal */
export type CodeResult$Outbound = {
  session_id: string;
  runtime: string;
  cwd: string;
  stdout: string;
  stderr: string;
  exit_code: number;
  files_changed?: Array<string> | undefined;
  resource_usage?: RuntimeResourceUsage$Outbound | null | undefined;
};

/** @internal */
export const CodeResult$outboundSchema: z.ZodType<
  CodeResult$Outbound,
  z.ZodTypeDef,
  CodeResult
> = z.object({
  sessionId: z.string(),
  runtime: CodeRuntime$outboundSchema,
  cwd: z.string(),
  stdout: z.string().default(""),
  stderr: z.string().default(""),
  exitCode: z.number().int(),
  filesChanged: z.array(z.string()).optional(),
  resourceUsage: z.nullable(RuntimeResourceUsage$outboundSchema).optional(),
}).transform((v) => {
  return remap$(v, {
    sessionId: "session_id",
    exitCode: "exit_code",
    filesChanged: "files_changed",
    resourceUsage: "resource_usage",
  });
});

export function codeResultToJSON(codeResult: CodeResult): string {
  return JSON.stringify(CodeResult$outboundSchema.parse(codeResult));
}
export function codeResultFromJSON(
  jsonString: string,
): SafeParseResult<CodeResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CodeResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CodeResult' from JSON`,
  );
}
